import { Editor } from "tldraw"
import { Parameter } from "../shared/Parameter"
import { LDPage } from "../shared/LDPage"
import { Expr } from "../shared/Expr"
import { ParamDefaults } from "./canvas-ui/ParameterializableControl"

export const createParameter = (type: Parameter["type"], editor: Editor) => {
  let p: Parameter | null = null

  const page = editor.getCurrentPage() as LDPage
  const existingParams = Object.values(page.meta.parameters)

  var num =
    Object.entries(page.meta.parameters).filter((p) => p[1].type === type)
      .length + 1
  while (existingParams.some((p) => p.name === `${type}${num}`)) {
    num++
  }

  const newParamId = `${type}-${num}`
  const parameterValues = {
    ...page.meta.parameterValues,
    [newParamId]: Expr.lit(ParamDefaults[type]),
  }

  switch (type) {
    case "color":
      p = {
        name: `color${num}`,
        type: "color",
      }
      break
    case "number":
      p = {
        name: `number${num}`,
        type: "number",
      }
      break
    case "boolean":
      p = {
        name: `boolean${num}`,
        type: "boolean",
      }
      break
    case "string":
      p = {
        name: `text${num}`,
        type: "string",
      }
      break
  }
  editor.updatePage({
    ...page,
    meta: {
      ...page.meta,
      parameters: {
        ...page.meta.parameters,
        [newParamId]: p,
      },
      parameterValues,
    },
  })
}
